

/*window.addEventListener('DOMContentLoaded', function() {

  const injectShopifyStyles = () => {
    const host = document.querySelector('#app-embed');

    if (host && host.shadowRoot) {
      
      if (!host.shadowRoot.querySelector('#custom-form-styles')) {
        const styleTag = document.createElement('style');
        styleTag.id = 'custom-form-styles';
        */

const observer = new MutationObserver(() => {
  const host = document.querySelector('#app-embed');
  if (host) {
    console.log('found it', host);
    observer.disconnect();
  }
});

function injectShopifyStyles() {
  const host = document.querySelector('#app-embed');

  if (host && host.shadowRoot) {
    if (!host.shadowRoot.querySelector('#custom-form-styles')) {
      const styleTag = document.createElement('style');
        styleTag.id = 'custom-form-styles';
        styleTag.textContent = `
          :host {

          /* global styles */ 
            --forms-body-font: normal var(--typeBaseWeight) var(--typeBaseSize) var(--typeBasePrimary), var(--typeBaseFallback) !important;
            --forms-heading-font: normal var(--typeHeaderWeight) var(--typeHeaderSize) var(--typeHeaderPrimary), var(--typeHeaderFallback) !important;
            --form-text-color: var(--colorTextBody) !important;
            --link-text-color: var(--colorTextLinks) !important;
            --heading-text-color: var(--colorTextHeader) !important;

            --button-background-color: var(--colorBtnPrimary) !important;
            --button-text-color: var(--colorBtnPrimaryText) !important;
            --button-border-radius: 40px !important;
            --button-border: 1px solid var(--button-text-color) !important;

            --form-field-border: none !important;
            --form-field-border-focused: none !important;
            --form-placeholder-color: var(--colorTextBody) !important;
            --form-background-color: #00000000 !important;
            --form-field-padding: 0.5rem;
            --inline-container-max-width: 950px;
          }

          input, 
          textarea, 
          select, 
          button:not([type="submit"]) {
            border: none !important;
            border-bottom: 1px solid #651916 !important;
            border-radius: 0 !important;
          }

          button[type="submit"],
          input[type="submit"] {
            border: 1px solid #651916 !important;
            border-radius: 40px !important;
          }

          form {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 1.5rem !important;
            justify-content: space-between !important;
          }

          form > div:first-child,
          [role="alert"] {
            grid-column: 1 / -1 !important;
            display: none !important;
            width: 100% !important;
          }

          form > div:has(textarea),
          button[type="submit"] {
            grid-column: 1 / -1 !important;
          }

          button[type="submit"] {
            justify-self: center !important; 
            width: fit-content !important;
            padding: .7rem 2.5rem !important;
            margin-bottom: 1rem !important;
          }

          ._arrowDownIcon_12thd_19 svg {
            display: none !important;
          }

          ._arrowDownIcon_12thd_19 {
            display: inline-block !important;
            width: 15px !important;
            height: 25px !important;
            background-image: url(https://cdn.shopify.com/s/files/1/0951/8491/2664/files/Vector_8.svg?v=1775889429) !important;
            background-repeat: no-repeat !important;
            background-size: 12px !important;
            background-position: center center !important;
          }
        
          /* custom dropdown text placement */
          ._selectContainer_12thd_6 ._label_12thd_10._textBody_2aowh_10 {
            position: absolute !important;
            padding-top: 0.9rem !important;
            padding-left: 0.5rem !important;
          }
          
          /* custom text area */
          textarea {
            height: 7rem !important;
            margin-bottom: 2rem !important;
          }

          label[id="label-custom#comment"] {
            top: auto !important;
            bottom: 2.5rem !important;
            position: absolute !important;
            left: 0 !important;
          } 

          ._selectToggle_12thd_25 span {
            min-height: 0 !important;
            background-color: #FBF5E8 !important; 
          }

          ._formDisclaimer_cit2d_38 p {
          font-size: 16px !important;
          line-height: 1.2rem !important;
          }

        @media screen and (min-width: 1367px) {
          input:focus + label[id^="label-"],
          input:not(:placeholder-shown) + label[id^="label-"],
          textarea:focus + label[id="label-custom#comment"],
          ._formInputField_nag3b_7:not(:placeholder-shown) + label,
          label._inputFilled_1mxsl_74 {
            opacity: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
          }
        }

        @media screen and (max-width: 1366px) {
          label._inputFilled_1mxsl_74 {
            opacity: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
          }

          ._selectContainer_12thd_6:has(._selectToggleText_12thd_25:not(:empty)) ._label_12thd_10 {
            display: none !important;
          }

          ._selectToggleText_12thd_25 {
            min-height: 1rem !important;
          }

          form {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
            justify-content: space-between !important;
          }

          form > div, 
          form > div:nth-child(n) {
          grid-column: span 1 !important;
          }

          label[id="label-custom#comment"] {
            top: 1rem !important;
            bottom: auto !important;
          } 
        }
        `;

        host.shadowRoot.appendChild(styleTag);
      }

      /*
        document.querySelector('#app-embed').style.visibility = 'visible';
        document.querySelector('#app-embed').style.opacity = '1';*/

            host.style.visibility = 'visible';
    host.style.opacity = '1';

    }

  };


function init() {
  const observer = new MutationObserver(() => {
    const host = document.querySelector('#app-embed');
    if (host && host.shadowRoot) {
      injectShopifyStyles();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  injectShopifyStyles();
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

/*
  const autoChecker = setInterval(injectShopifyStyles, 500);
  setTimeout(() => clearInterval(autoChecker), 10000);
});
*/